import { Navigate, useLocation } from 'react-router'

/**
 * Redirects legacy URLs (without language prefix) to the English version.
 * Preserves the path, query parameters, and hash fragment.
 *
 * Example: /dashboard?tab=active → /en/dashboard?tab=active
 * Example: /auth/callback#access_token=xxx → /en/auth/callback#access_token=xxx
 */
export function LegacyRedirect() {
  const location = useLocation()

  // Build the new URL with /en prefix, preserving path, query params, and hash
  const newPath = `/en${location.pathname}${location.search}${location.hash}`

  return <Navigate to={newPath} replace />
}
